"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _reactNativeWeb = require("react-native-web");

var _crossPlatformComponents = require("@airasia/cross-platform-components");

var _AaIconList = _interopRequireDefault(require("@airasia/cross-platform-components/components/airasia-icon-component/AaIconList"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// const DATA = [
//     {
//         title: "List",
//         data: [
//             {
//                 label: "1",
//                 value: 1
//             },
//             {
//                 label: "2",
//                 value: 2
//             },
//             {
//                 label: "3",
//                 value: 1
//             },
//             {
//                 label: "4",
//                 value: 2
//             },
//             {
//                 label: "5",
//                 value: 1
//             },
//             {
//                 label: "6",
//                 value: 2
//             }, {
//                 label: "7",
//                 value: 1
//             },
//             {
//                 label: "8",
//                 value: 2
//             }
//         ]
//     }
// ]
var styles = _crossPlatformComponents.StyleSheet.create({
  input: {
    height: 48,
    width: '100%',
    borderColor: '#D9DBE0',
    borderRadius: 3,
    borderWidth: 1,
    flexDirection: 'row'
  },
  label: {
    fontSize: 12,
    top: 4,
    left: 16,
    position: 'absolute',
    color: '#4C4C50'
  },
  placeHolder: {
    marginLeft: 15,
    marginRight: 5,
    marginTop: 20,
    fontWeight: "500",
    fontSize: 16,
    paddingTop: 2,
    color: '#4C4C50'
  },
  defaultItemLabel: {
    marginLeft: 15,
    marginRight: 5,
    marginTop: 20,
    fontWeight: "500",
    fontSize: 16,
    paddingTop: 2,
    color: '#212124'
  },
  itemWrapper: (0, _defineProperty2["default"])({
    borderWidth: 1,
    position: 'absolute',
    bottom: 57,
    left: 10,
    zIndex: 1000,
    width: '100%',
    backgroundColor: '#000000',
    marginBottom: 10,
    borderColor: '#D9DBE0',
    borderRadius: 3
  }, "borderWidth", 1),
  sectionWrapper: {
    maxHeight: 150,
    backgroundColor: '#ffffff',
    zIndex: 10
  },
  item: {
    width: '100%',
    backgroundColor: '#ffffff',
    minHeight: 20,
    padding: 4
  },
  itemLabel: {
    marginLeft: 15
  },
  iconWrapper: {
    marginTop: 18,
    marginRight: 5
  },
  inputWapper: {
    flex: 1
  }
});

var Item = function Item(_ref) {
  var item = _ref.item,
      onSelect = _ref.onSelect;
  return /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableOpacity, {
    style: styles.item,
    onPress: function onPress() {
      onSelect(item);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: styles.itemLabel
  }, item.label));
};

var AaPicker = function AaPicker(_ref2) {
  var onSelectItemHandle = _ref2.onSelectItemHandle,
      defaultItem = _ref2.defaultItem,
      data = _ref2.data,
      label = _ref2.label,
      _ref2$placeHolder = _ref2.placeHolder,
      placeHolder = _ref2$placeHolder === void 0 ? '' : _ref2$placeHolder;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      showPopupAge = _useState2[0],
      setShowPopupAge = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      selectedItem = _useState4[0],
      setSelectedItem = _useState4[1];

  var _useState5 = (0, _react.useState)([]),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      listData = _useState6[0],
      setListData = _useState6[1];

  var onSetDefaultValue = (0, _react.useCallback)(function () {
    if (defaultItem && data && data.length) {
      var itemSelected = data.find(function (i) {
        return i.value === defaultItem.value;
      });
      if (itemSelected) setSelectedItem(itemSelected);else setSelectedItem(data[0]);
    }
  }, [defaultItem, data]);
  var createListData = (0, _react.useCallback)(function () {
    if (data.length > 0) {
      setListData([{
        title: '',
        data: data
      }]);
    }
  }, [data]);
  (0, _react.useEffect)(function () {
    onSetDefaultValue();
    createListData();
  }, [defaultItem, data]);

  var onSelectItem = function onSelectItem(item) {
    setSelectedItem(item);
    setShowPopupAge(false);
    if (onSelectItemHandle) onSelectItemHandle(item);
  };

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.TouchableOpacity, {
    onPress: function onPress() {
      setShowPopupAge(true);
    }
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, null, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.input
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.inputWapper
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: styles.label
  }, label), Boolean(selectedItem) && Boolean(selectedItem.label) && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: styles.defaultItemLabel
  }, selectedItem.label), Boolean(placeHolder) && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.Text, {
    style: styles.placeHolder
  }, placeHolder)), /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.iconWrapper
  }, /*#__PURE__*/_react["default"].createElement(_crossPlatformComponents.AaIconComponent, {
    controls: {
      iconName: 'ARROW_DOWN',
      iconStyle: {
        height: 8,
        width: 12
      }
    }
  }))))), showPopupAge && /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.View, {
    style: styles.itemWrapper
  }, /*#__PURE__*/_react["default"].createElement(_reactNativeWeb.SectionList, {
    stickySectionHeadersEnabled: true,
    style: styles.sectionWrapper,
    sections: listData // ListEmptyComponent={()=><Text>Empty </Text>}
    ,
    renderItem: function renderItem(item, index) {
      return /*#__PURE__*/_react["default"].createElement(Item, {
        item: item.item,
        onSelect: onSelectItem
      });
    },
    keyExtractor: function keyExtractor(item, index) {
      return item + index;
    }
  })));
};

var _default = AaPicker;
exports["default"] = _default;